export const templates = {
  Art: [
    {
      id: 71,
      created_at: '2023-07-19T15:27:06.313956+00:00',
      prompt:
        'A steampunk cityscape full of intricate gears and machinery, airships flying in the sky, industrial revolution inspired, ultra-realistic, high detail',
      categories: 'Art,Wallpapers,Comics',
      example_image_url:
        'https://static.tryleap.ai/image-gen-f29ad67c-7c8b-4c0a-89c3-1479b8c507c3/generated_images/1.png',
      list: 'default',
      priority: 0,
    },
    // {
    //   id: 120,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of A tranquil and idyllic countryside scene, with a meandering river, grazing cows, and colorful wildflowers.',
    //   categories: 'Wallpapers,Art',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-6d513e29-a22f-472c-a1ed-e6ba58069cdb/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 140,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     "8k portrait in the style of Pablo Picasso's 'Cubism,' with fragmented geometric forms, abstracted figures, and bold colors.",
    //   categories: 'Characters,Art',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-377e262b-b156-4fda-b85a-0f1604591da6/generated_images/0.png',
    //   list: 'default',
    //   priority: 0,
    // },
    {
      id: 141,
      created_at: '2023-07-19T15:27:06.313956+00:00',
      prompt:
        "8k portrait influenced by Salvador Dalí's 'Surrealism,' featuring unexpected juxtapositions, melting objects, and a dreamlike atmosphere.",
      categories: 'Characters,Art',
      example_image_url:
        'https://static.tryleap.ai/image-gen-1d49f9ba-a335-4ada-a6b4-77972c4c5788/generated_images/2.png',
      list: 'default',
      priority: 0,
    },
    // {
    //   id: 142,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     "8k portrait in the style of Jackson Pollock's 'Abstract Expressionism,' featuring drips, splatters, and energetic brushwork.",
    //   categories: 'Characters,Art',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-b08d07d8-59f7-4dd6-ad04-12da5b7fa909/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 143,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     "8k portrait influenced by Frida Kahlo's 'Surrealism,' with symbolic elements, vibrant colors, and introspective themes.",
    //   categories: 'Characters,Art',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-c31678b3-09b3-4929-898c-d0bca83e8e66/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    {
      id: 144,
      created_at: '2023-07-19T15:27:06.313956+00:00',
      prompt:
        "8k portrait in the style of Henri Matisse's 'Fauvism,' with bold colors, simplified forms, and expressive brushwork.",
      categories: 'Characters,Art',
      example_image_url:
        'https://static.tryleap.ai/image-gen-3b5af0b4-f563-4a22-8c60-7320ec51e9d2/generated_images/1.png',
      list: 'default',
      priority: 0,
    },
    // {
    //   id: 145,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     "8k portrait inspired by Wassily Kandinsky's 'Abstract Art,' featuring geometric shapes, vibrant colors, and spiritual themes.",
    //   categories: 'Wallpapers,Art',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-d831eb0a-5562-419c-85e0-b87eb37fa573/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 146,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     "8k portrait influenced by Georgia O'Keeffe's 'Modernism,' with enlarged flowers, desert landscapes, and delicate details.",
    //   categories: 'Characters,Art',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-7620b262-3bca-489e-b9d4-97bb09ed0741/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    {
      id: 147,
      created_at: '2023-07-19T15:27:06.313956+00:00',
      prompt:
        "8k portrait in the style of Leonardo da Vinci's 'Renaissance,' with realistic proportions, sfumato technique, and classical composition.",
      categories: 'Characters,Art',
      example_image_url:
        'https://static.tryleap.ai/image-gen-f3f75431-27cc-4acb-b416-415a6f72a9bf/generated_images/2.png',
      list: 'default',
      priority: 0,
    },
    // {
    //   id: 190,
    //   created_at: '2023-07-19T17:42:52.231822+00:00',
    //   prompt:
    //     'Retro comic style artwork, highly detailed spiderman, comic book cover, symmetrical, vibrant',
    //   categories: 'Comics,Art,Characters',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-0891704a-c983-44f1-a63a-20eb9fa99388/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 56,
    //   created_at: '2023-07-19T04:36:14.775547+00:00',
    //   prompt:
    //     'A bustling Parisian street scene at sunset, with vibrant colors and visible brush strokes, reminiscent of Impressionist masters like Claude Monet or Pierre-Auguste Renoir, high resolution, intricately detailed',
    //   categories: '["Art","Wallpapers"]',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-4070b58c-76a8-4083-9434-94b0caf09db2/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 59,
    //   created_at: '2023-07-19T15:20:10.283188+00:00',
    //   prompt:
    //     'galaxy full of colors, vibrant, epic composition, cinematic, Landscape veduta photo by Dan Mumford, detailed landscape painting, rendered in Enscape, Miyazaki, Nausicaa Ghibli, 4k detailed post processing, unreal engine',
    //   categories: 'Art,Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-f065cdd8-8cf9-47e1-8202-d1690b34d9d2/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 60,
    //   created_at: '2023-07-19T15:20:10.283188+00:00',
    //   prompt:
    //     'futuristic tree house, hyper realistic, epic composition, cinematic, landscape vista photography by Carr Clifton & Galen Rowell, Landscape veduta photo by Dustin Lefevre & tdraw, detailed landscape painting by Ivan Shishkin, rendered in Enscape, Miyazaki, Nausicaa Ghibli, 4k detailed post processing, unreal engine',
    //   categories: 'Art,Wallpapers,Comics',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-143abe1b-7910-4874-8864-2d6052ee18b7/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 64,
    //   created_at: '2023-07-19T15:25:04.015728+00:00',
    //   prompt:
    //     'rustic countryside scene with wildflowers and a meandering stream; warm, golden light, pastoral landscape style, rich greens and vibrant blooms, photographed with a high-quality wide-angle lens',
    //   categories: 'Art,Wallpapers,Comics',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-eb438c1b-8e9b-45d7-be94-d0af03e8643f/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 68,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'An ancient and mystical forest, lit by moonlight, with towering trees, moss-covered stones, and a small, clear stream, inspired by a fantasy novel, high resolution, highly detailed',
    //   categories: 'Art,Wallpapers,Comics',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-612a5530-7536-42d5-b203-14600120f64b/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 69,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'futuristic sunset New York City skyline landscape vista photography by Carr Clifton & Galen Rowell, 16K resolution, Landscape veduta photo by Dustin Lefevre & tdraw, 8k resolution, detailed landscape painting by Ivan Shishkin, DeviantArt, Flickr, rendered in Enscape, Miyazaki, Nausicaa Ghibli, Breath of The Wild, 4k detailed post processing, atmospheric, hyper realistic, 8k, epic composition, cinematic, artstation —ar 16:9',
    //   categories: 'Art,Wallpapers,Comics',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-5a41bf2f-b69d-41f9-8d91-9b0f17db79ba/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
  ],
  Characters: [
    {
      id: 48,
      created_at: '2023-07-19T04:31:01.885863+00:00',
      prompt: '8k portrait of a model in a turquoise dress',
      categories: '["Characters","Stock Photos"]',
      example_image_url:
        'https://static.tryleap.ai/image-gen-745600b0-fe35-46ec-a127-9ea7b0b99eda/generated_images/0.png',
      list: 'default',
      priority: 5,
    },
    // {
    //   id: 52,
    //   created_at: '2023-07-19T04:33:06.215451+00:00',
    //   prompt:
    //     '8k portrait of an enchanting, highly detailed image of a fairy in a magical forest, surrounded by sparkling lights and vibrant flora, captured in soft, dreamy lighting',
    //   categories: '["Characters","Stock Photos"]',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-8bf0de2c-673a-46e0-8b20-bbd471c71d62/generated_images/3.png',
    //   list: 'default',
    //   priority: 5,
    // },
    {
      id: 198,
      created_at: '2023-07-19T17:54:43.564979+00:00',
      prompt:
        '3d fluffy squirrel, closeup cute and adorable, cute big circular reflective eyes, long fuzzy fur, Pixar render, unreal engine cinematic smooth, intricate detail, cinematic',
      categories: 'Characters,3D',
      example_image_url:
        'https://static.tryleap.ai/image-gen-1b60ad6d-c7e5-4459-9dc1-38a126757fad/generated_images/0.png',
      list: 'default',
      priority: 2,
    },
    // {
    //   id: 197,
    //   created_at: '2023-07-19T17:53:55.680166+00:00',
    //   prompt:
    //     '3d fluffy grizzly bear, closeup cute and adorable, cute big circular reflective eyes, long fuzzy fur, Pixar render, unreal engine cinematic smooth, intricate detail, cinematic',
    //   categories: 'Characters,3D',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-614cbd2b-091f-4b90-b609-ea009d04a54d/generated_images/3.png',
    //   list: 'default',
    //   priority: 2,
    // },
    // {
    //   id: 196,
    //   created_at: '2023-07-19T17:52:03.374899+00:00',
    //   prompt:
    //     '3d fluffy llama, closeup cute and adorable, cute big circular reflective eyes, long fuzzy fur, Pixar render, unreal engine cinematic smooth, intricate detail, cinematic',
    //   categories: 'Characters,3D',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-bbe602e4-2089-403c-8184-efe296ccebb0/generated_images/0.png',
    //   list: 'default',
    //   priority: 2,
    // },
    // {
    //   id: 199,
    //   created_at: '2023-07-19T17:55:37.591413+00:00',
    //   prompt:
    //     '3d fluffy koala, closeup cute and adorable, cute big circular reflective eyes, long fuzzy fur, Pixar render, unreal engine cinematic smooth, intricate detail, cinematic',
    //   categories: 'Characters,3D',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-abfdd7ed-3ddb-43e5-a60e-0ea338d79bfd/generated_images/1.png',
    //   list: 'default',
    //   priority: 2,
    // },
    {
      id: 221,
      created_at: '2023-08-18T10:47:38.254067+00:00',
      prompt:
        'Glamorous portrait of {KEYWORD} as ultra-realistic barbie, wearing a beautiful headband, pink backdrop, elegant white evening gown with beadwork, styled hair with a headband, sparkling makeup, shot in 8k with an 85mm sony g master lens, capturing modern barbie-inspired elegance',
      categories: 'Stock Photos, Characters',
      example_image_url:
        'https://static.tryleap.ai/image-gen-7ba64bdd-c98f-43e9-9542-066055b3e9ce/generated_images/2.png',
      list: 'gender_neutral',
      priority: 1,
    },
    // {
    //   id: 140,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     "8k portrait in the style of Pablo Picasso's 'Cubism,' with fragmented geometric forms, abstracted figures, and bold colors.",
    //   categories: 'Characters,Art',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-377e262b-b156-4fda-b85a-0f1604591da6/generated_images/0.png',
    //   list: 'default',
    //   priority: 0,
    // },
    {
      id: 141,
      created_at: '2023-07-19T15:27:06.313956+00:00',
      prompt:
        "8k portrait influenced by Salvador Dalí's 'Surrealism,' featuring unexpected juxtapositions, melting objects, and a dreamlike atmosphere.",
      categories: 'Characters,Art',
      example_image_url:
        'https://static.tryleap.ai/image-gen-1d49f9ba-a335-4ada-a6b4-77972c4c5788/generated_images/2.png',
      list: 'default',
      priority: 0,
    },
    // {
    //   id: 142,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     "8k portrait in the style of Jackson Pollock's 'Abstract Expressionism,' featuring drips, splatters, and energetic brushwork.",
    //   categories: 'Characters,Art',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-b08d07d8-59f7-4dd6-ad04-12da5b7fa909/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 143,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     "8k portrait influenced by Frida Kahlo's 'Surrealism,' with symbolic elements, vibrant colors, and introspective themes.",
    //   categories: 'Characters,Art',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-c31678b3-09b3-4929-898c-d0bca83e8e66/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    {
      id: 144,
      created_at: '2023-07-19T15:27:06.313956+00:00',
      prompt:
        "8k portrait in the style of Henri Matisse's 'Fauvism,' with bold colors, simplified forms, and expressive brushwork.",
      categories: 'Characters,Art',
      example_image_url:
        'https://static.tryleap.ai/image-gen-3b5af0b4-f563-4a22-8c60-7320ec51e9d2/generated_images/1.png',
      list: 'default',
      priority: 0,
    },
    // {
    //   id: 146,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     "8k portrait influenced by Georgia O'Keeffe's 'Modernism,' with enlarged flowers, desert landscapes, and delicate details.",
    //   categories: 'Characters,Art',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-7620b262-3bca-489e-b9d4-97bb09ed0741/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    {
      id: 147,
      created_at: '2023-07-19T15:27:06.313956+00:00',
      prompt:
        "8k portrait in the style of Leonardo da Vinci's 'Renaissance,' with realistic proportions, sfumato technique, and classical composition.",
      categories: 'Characters,Art',
      example_image_url:
        'https://static.tryleap.ai/image-gen-f3f75431-27cc-4acb-b416-415a6f72a9bf/generated_images/2.png',
      list: 'default',
      priority: 0,
    },
    {
      id: 202,
      created_at: '2023-07-20T00:46:39.729762+00:00',
      prompt:
        "8k 80's portrait of {KEYWORD}, close up shot in fifa world cup, football 1980, full face details, cinematic lighting, hyper realistic facial features, ultra detailed, canon eos 5d, 100mm f/1.8, iso100",
      categories: 'Characters',
      example_image_url:
        'https://static.tryleap.ai/image-gen-2f1cad58-a295-4025-8dde-4ab14ea028bc/generated_images/1.png',
      list: 'gender_neutral',
      priority: 0,
    },
    {
      id: 189,
      created_at: '2023-07-19T17:28:59.286179+00:00',
      prompt:
        '8k portrait of close-up high-resolution image of a fierce Viking warrior in battle gear, icy Nordic landscape in the background, captured in dramatic lighting with highly detailed composition',
      categories: 'Stock Photos,Characters',
      example_image_url:
        'https://static.tryleap.ai/image-gen-f793ef02-bd92-431d-a27f-6b73c5777383/generated_images/1.png',
      list: 'default',
      priority: 0,
    },
    // {
    //   id: 190,
    //   created_at: '2023-07-19T17:42:52.231822+00:00',
    //   prompt:
    //     'Retro comic style artwork, highly detailed spiderman, comic book cover, symmetrical, vibrant',
    //   categories: 'Comics,Art,Characters',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-0891704a-c983-44f1-a63a-20eb9fa99388/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 203,
    //   created_at: '2023-07-20T00:59:08.031042+00:00',
    //   prompt:
    //     '8k cartoon portrait of {KEYWORD} as a highly detailed fairy in a magical forest, enchanting, surrounded by sparkling lights and vibrant flora, captured in soft, dreamy lighting',
    //   categories: 'Characters',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-020e5b80-7036-44ab-a021-d6c05654212a/generated_images/1.png',
    //   list: 'gender_neutral',
    //   priority: 0,
    // },
    // {
    //   id: 206,
    //   created_at: '2023-07-21T23:14:23.068191+00:00',
    //   prompt:
    //     'realistic half-bust portrait photography of a beautiful {KEYWORD} face illuminated by neon lights, maniac tv series style, cyberpunk background, perfectly drawn eyes, perfectly drawn circles, high resolution, ultra realistic, sharp features, white balance, 32k, super-resolution, sharp focus, soft smooth lighting',
    //   categories: 'Characters, Stock Photos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-92d1e2d7-521b-4a2c-9187-a318b2dfa261/generated_images/3.png',
    //   list: 'gender_neutral',
    //   priority: 0,
    // },
    // {
    //   id: 207,
    //   created_at: '2023-07-21T23:22:05.268099+00:00',
    //   prompt:
    //     'realistic photography of {KEYWORD}, a white statue bust of {KEYWORD}, on a podium, studio photography of {KEYWORD}, high resolution, high resolution textures, ultra realistic, sharp features, 32k, super-resolution, sharp focus, perfectly sculpted eyes',
    //   categories: 'Characters',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-b7bbb4bc-f880-4e58-bb07-5a345a18b859/generated_images/3.png',
    //   list: 'gender_neutral',
    //   priority: 0,
    // },
    {
      id: 209,
      created_at: '2023-07-21T23:29:53.533589+00:00',
      prompt:
        '8k portrait of {KEYWORD} as retro comic style artwork, highly detailed spiderman, comic book cover, symmetrical, vibrant',
      categories: 'Characters',
      example_image_url:
        'https://static.tryleap.ai/image-gen-687dd7ff-97d8-4a87-9a2b-5967732ea338/generated_images/3.png',
      list: 'gender_neutral',
      priority: 0,
    },
    {
      id: 211,
      created_at: '2023-07-21T23:32:42.312702+00:00',
      prompt:
        "8k portrait of {KEYWORD}, jackson pollock's 'abstract expressionism,' featuring drips, splatters, and energetic brushwork.",
      categories: 'Characters',
      example_image_url:
        'https://static.tryleap.ai/image-gen-732e183f-2f26-478a-944b-ab322134cb07/generated_images/0.png',
      list: 'gender_neutral',
      priority: 0,
    },
    {
      id: 215,
      created_at: '2023-07-22T00:03:58.942589+00:00',
      prompt: 'a bird {KEYWORD}, black background, orange forefront',
      categories: 'Characters',
      example_image_url:
        'https://static.tryleap.ai/image-gen-08566ade-734c-4418-8386-3263c13a4706/generated_images/3.png',
      list: 'style',
      priority: 0,
    },
    {
      id: 213,
      created_at: '2023-07-21T23:42:30.579232+00:00',
      prompt:
        "(masterpiece) anime of {KEYWORD} 80's style art, superb quality,  portrait of a gorgeous {KEYWORD}, close up, wearing post apocaliptic clothes, longing,  wasteland, scorching heat, sunny, looking up, ( shaded colors:1.3), poster, coverart, (perfect body proportions:1.2), perfect face, perfect eyes, crisp, 8k, intricate hnkstyle, 80's anime, movie quality, lovely, romantic, perfect long legs, calm,  bhands-neg, perfect hands, 1 subject",
      categories: 'Characters',
      example_image_url:
        'https://static.tryleap.ai/image-gen-ef130efe-2518-4d67-9ab9-a15713185dde/generated_images/1.png',
      list: 'female',
      priority: 0,
    },
    // {
    //   id: 44,
    //   created_at: '2023-07-19T04:26:25.956685+00:00',
    //   prompt:
    //     '8k portrait of a classic scene from a spaghetti western movie, featuring a gunslinger in a dusty desert town, high noon, sun directly overhead, photorealistic, highly detailed',
    //   categories: '["Characters","Stock Photos"]',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-ffac2b1d-a011-4eee-9b3a-643dc18f6ff8/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    {
      id: 46,
      created_at: '2023-07-19T04:29:19.793509+00:00',
      prompt:
        '8k portrait of an indian woman as a jedi, star wars revenge of the sith movie scene style, studio photography, volumetric lighting, smiling, realistic, 35mm, expressive, iconic, 8k concept art, photorealistic, high detail',
      categories: '["Characters"]',
      example_image_url:
        'https://static.tryleap.ai/image-gen-51e4939c-8e5f-403f-b981-fc712a05f61e/generated_images/0.png',
      list: 'default',
      priority: 0,
    },
    {
      id: 50,
      created_at: '2023-07-19T04:31:59.083288+00:00',
      prompt:
        'An epic, detailed, and high-resolution portrait of a medieval knight in full armor, set against the backdrop of a grand castle, captured in dramatic lighting with highly detailed composition',
      categories: '["Characters","Stock Photos"]',
      example_image_url:
        'https://static.tryleap.ai/image-gen-9dfa4676-1770-4364-813c-e1904829462e/generated_images/3.png',
      list: 'default',
      priority: 0,
    },
    {
      id: 53,
      created_at: '2023-07-19T04:34:10.766781+00:00',
      prompt:
        "8k portrait of a charismatic ninja character in dynamic action, anime style, reminiscent of popular shows like 'Naruto', 'high resolution, vibrant and detailed'",
      categories: '["Characters","Comics"]',
      example_image_url:
        'https://static.tryleap.ai/image-gen-b12ae973-cfee-4e02-b654-f864df9ebd65/generated_images/0.png',
      list: 'default',
      priority: 0,
    },
    // {
    //   id: 54,
    //   created_at: '2023-07-19T04:35:11.008245+00:00',
    //   prompt:
    //     "8k portrait, classic Disney-style princess, pixar style, with flowing auburn hair, dressed in a regal gown, standing in front of her grand castle, in the distinct style of Disney classics like 'Beauty and the Beast' or 'Tangled', high resolution, colorful and detailed",
    //   categories: '["Characters","Comics"]',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-3f6f687e-bb36-4b57-86d2-a86658693904/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
  ],
  Icons: [
    {
      id: 77,
      created_at: '2023-07-19T15:27:06.313956+00:00',
      prompt:
        'A minimalist, flat design icon representing a cloud, with clean lines and neutral colors, ideally suited for a weather app, high resolution, detailed',
      categories: 'Logos,Icons',
      example_image_url:
        'https://static.tryleap.ai/image-gen-9b29936d-9f71-4419-b3da-1e8ce1a3009a/generated_images/1.png',
      list: 'default',
      priority: 0,
    },
    // {
    //   id: 79,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'A clay style icon depicting a house, with soft edges and muted colors, conveying a warm and cozy feeling, high resolution, detailed and tactile',
    //   categories: 'Logos,Icons',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-d7ebd202-12d6-4f54-86e3-16cb654f874e/generated_images/0.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 80,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'A pixelated icon of a retro video game controller, with crisp, blocky lines and vibrant colors, evoking nostalgia, high resolution, classic and detailed',
    //   categories: 'Logos,Icons',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-a241abe7-e788-4dc1-a4b3-9ab98d2f2b5e/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 82,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'A metallic icon representing a gear, with shiny, reflective surfaces and a sleek design, high resolution, detailed and sophisticated',
    //   categories: 'Logos,Icons',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-14c9cf22-b86c-42dc-abc5-9c1270b6d86e/generated_images/0.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 148,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Minimalist icon of a camera capturing a decisive moment, with clean lines and simplified shapes.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-91b297e9-5f53-4abe-a28c-308fcaf00b87/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 149,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Abstract logo design representing interconnectedness and collaboration, with overlapping geometric shapes.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-70c08cd2-53e6-4afb-9f21-16feea24f950/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 150,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Simple and versatile icon of a book, representing knowledge, education, or reading.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-e47ffa0e-6702-464f-a901-3919bf9fe473/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 151,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Iconic representation of a lightbulb, symbolizing ideas, creativity, or innovation.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-4b1cb453-4534-441a-8f67-6b29df1592fc/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 152,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Create a sleek and modern icon representing communication and connectivity, with abstract lines and nodes.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-445df41d-3a6e-43e9-8bc3-4a5ec06d09f0/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 153,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     "Craft a playful and colorful icon for a children's educational app, featuring a friendly animal character.",
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-a60f3a02-a3c6-4c0a-ae3e-f9b92b60a401/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 154,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Create a vibrant and dynamic icon for a fitness app, showcasing a person engaged in a workout or exercise.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-6494b1df-2c2d-4057-ac90-9ac25be6e8aa/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 155,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Design a unique and eye-catching logo for a coffee shop, incorporating a coffee cup and steam in a creative way.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-b6fb55f3-1dfa-44d6-9fd3-b6f6f6649397/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 156,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Create a cute and charming icon for a pet care app, featuring a paw print or a friendly animal face.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-9c48e740-e498-4fde-a41c-a3e46b77332b/generated_images/0.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 157,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Craft an icon representing travel and adventure, featuring a suitcase, compass, or a landmark symbol.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-296c823a-098f-469f-be1b-e5feceb77028/generated_images/0.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 158,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Create a playful and vibrant icon for a gaming app, showcasing a game controller, joystick, or a character.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-b72f3ae3-b5da-44cb-99ba-5d058ec75525/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 159,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Design a clay-style logo with a sculpted look, providing a tactile and handcrafted aesthetic.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-66249cdf-9cfd-4008-a957-1d95dda94647/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 160,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Craft a watercolor-inspired icon with soft, blended colors and delicate brushstrokes.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-fcc41de1-329b-4559-8e1f-5d1af4027eb7/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 161,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Design a neon-style logo with glowing lines and vibrant colors, giving a futuristic and eye-catching look.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-3c579678-2c95-4fd2-a8f4-ccf19b098679/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 162,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Craft a hand-drawn icon with sketchy lines and a loose, artistic style, adding a sense of authenticity.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-c7579e8c-b6d9-4304-bf99-59384f876162/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 165,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Craft a graffiti-style icon with bold, colorful strokes and urban-inspired lettering, capturing the energy of street art.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-36ff1080-d128-4ce7-a0be-13c057f16bf3/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 166,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Design a holographic logo with iridescent colors and a futuristic hologram effect, creating an otherworldly look.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-bc589656-0939-4c2b-a6c9-6db54bf3609c/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 168,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Develop a pop art-style logo with bold, vibrant colors and comic book-inspired elements, capturing a lively and playful spirit.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-dcdb3962-107a-47f0-b3bd-e597cfd5f9b5/generated_images/0.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 169,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Design a classic illustration-style logo with detailed linework, capturing a vintage and timeless feel.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-a1edacb1-ac0d-46e5-9eaa-1ee2cf9c26a4/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 170,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Create a captivating line art icon infused with vibrant watercolor colors, blending the charm of delicate brushstrokes with the simplicity of minimalistic black lines. Focus on achieving a harmonious balance between the fluidity of watercolors and the clean aesthetics of line art, resulting in an icon that exudes artistic expression and visual appeal.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-443aaa7e-7e4d-462d-81b8-e3cc9c69d210/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 171,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Create a line art icon of a blooming flower, with vibrant watercolor colors adding a touch of whimsy and elegance.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-7a6c144d-2c64-444e-9902-f97a6d93e01b/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 172,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Design a line art icon of a charming coffee cup, infused with soft watercolor hues that evoke a sense of warmth and relaxation.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-fc487577-8816-42ee-8625-e3965c07c883/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 173,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'Illustrate a line art icon of a vintage camera, embellished with subtle watercolor tones that evoke a nostalgic and artistic vibe.',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-2bd2fbc4-1f88-4492-b35d-9e16ae8819dd/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 214,
    //   created_at: '2023-07-22T00:01:09.242916+00:00',
    //   prompt:
    //     'a {KEYWORD} icon of a coffee cup, black background, orange forefront',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-d1f6d0b4-c441-419d-ac99-9d7b6dedd13d/generated_images/2.png',
    //   list: 'style',
    //   priority: 0,
    // },
    // {
    //   id: 216,
    //   created_at: '2023-07-22T00:11:22.075344+00:00',
    //   prompt:
    //     'design a continuous line art image that captures the transformative power of vulnerability and seeking help {KEYWORD} style',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-b9ef3065-8616-470e-a09e-a0f80110e4d0/generated_images/2.png',
    //   list: 'style',
    //   priority: 0,
    // },
    // {
    //   id: 217,
    //   created_at: '2023-07-22T00:12:18.092755+00:00',
    //   prompt:
    //     'design a line art icon of a small fish in a big pond {KEYWORD} style',
    //   categories: 'Logos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-348fae6c-9743-48ee-b88e-51a81c38b7cc/generated_images/3.png',
    //   list: 'style',
    //   priority: 0,
    // },
  ],
  // 'Stock photos': [
  //   {
  //     id: 32,
  //     created_at: '2023-07-19T04:15:02.167561+00:00',
  //     prompt:
  //       '8k portrait close up of face of beautiful woman fashion model in white feather clothes, official balmain editorial, dramatic lighting highly detailed, new york city in the background, ultra-realistic',
  //     categories: '["Stock Photos"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-1e80a8ea-c909-4066-86ad-b37973033496/generated_images/3.png',
  //     list: 'default',
  //     priority: 5,
  //   },
  //   {
  //     id: 48,
  //     created_at: '2023-07-19T04:31:01.885863+00:00',
  //     prompt: '8k portrait of a model in a turquoise dress',
  //     categories: '["Characters","Stock Photos"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-745600b0-fe35-46ec-a127-9ea7b0b99eda/generated_images/0.png',
  //     list: 'default',
  //     priority: 5,
  //   },
  //   {
  //     id: 87,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a captivating shot of wildlife in their natural habitat, showcasing the beauty and diversity of nature, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-083f1daf-a6a8-4e7a-b165-ebc06b6c0b73/generated_images/2.png',
  //     list: 'default',
  //     priority: 5,
  //   },
  //   {
  //     id: 31,
  //     created_at: '2023-07-19T04:14:12.276377+00:00',
  //     prompt:
  //       '8k portrait up-close and personal view of a roaring lion in the African savannah, sun setting in the background casting a golden light on the scene, high resolution, ultra-realistic',
  //     categories: '["Stock Photos"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-fce41119-5fb3-43c8-a892-169b2ff259b8/generated_images/3.png',
  //     list: 'default',
  //     priority: 5,
  //   },
  //   {
  //     id: 52,
  //     created_at: '2023-07-19T04:33:06.215451+00:00',
  //     prompt:
  //       '8k portrait of an enchanting, highly detailed image of a fairy in a magical forest, surrounded by sparkling lights and vibrant flora, captured in soft, dreamy lighting',
  //     categories: '["Characters","Stock Photos"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-8bf0de2c-673a-46e0-8b20-bbd471c71d62/generated_images/3.png',
  //     list: 'default',
  //     priority: 5,
  //   },
  //   {
  //     id: 128,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a stylish and fashionable handbag, featuring premium materials, intricate details, and a trendy design.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-e268416b-1b04-4f9e-9015-4dee9344e3b3/generated_images/1.png',
  //     list: 'default',
  //     priority: 4,
  //   },
  //   {
  //     id: 45,
  //     created_at: '2023-07-19T04:27:10.817986+00:00',
  //     prompt:
  //       '8k linkedin professional profile photo of a black man in a suit with studio lighting, bokeh, corporate portrait headshot photograph best corporate photography photo winner, meticulous detail, hyperrealistic, centered uncropped symmetrical beautiful',
  //     categories: '["Stock Photos"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-8c1a0269-e86e-46d6-8c31-6989e7959eac/generated_images/2.png',
  //     list: 'default',
  //     priority: 4,
  //   },
  //   {
  //     id: 126,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a delicious and tempting cupcake, with fluffy cake, creamy frosting, and colorful sprinkles on top.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-cc65ef84-8439-4f87-b1f7-aed9f21de240/generated_images/3.png',
  //     list: 'default',
  //     priority: 4,
  //   },
  //   {
  //     id: 37,
  //     created_at: '2023-07-19T04:19:05.950118+00:00',
  //     prompt:
  //       'A sleek, modern kitchen design featuring stainless steel appliances, marble countertops, and minimalist cabinets, photorealistic, high detail, inspired by Architectural Digest',
  //     categories: '["Stock Photos","Real Estate"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-084c4726-a6b0-4188-a1ef-675cda787fc8/generated_images/0.png',
  //     list: 'default',
  //     priority: 4,
  //   },
  //   {
  //     id: 221,
  //     created_at: '2023-08-18T10:47:38.254067+00:00',
  //     prompt:
  //       'Glamorous portrait of {KEYWORD} as ultra-realistic barbie, wearing a beautiful headband, pink backdrop, elegant white evening gown with beadwork, styled hair with a headband, sparkling makeup, shot in 8k with an 85mm sony g master lens, capturing modern barbie-inspired elegance',
  //     categories: 'Stock Photos, Characters',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-7ba64bdd-c98f-43e9-9542-066055b3e9ce/generated_images/2.png',
  //     list: 'gender_neutral',
  //     priority: 1,
  //   },
  //   {
  //     id: 220,
  //     created_at: '2023-08-18T10:01:54.668273+00:00',
  //     prompt:
  //       '8k high-fashion shot of {KEYWORD} as Ken from Barbie on a beach, blonde hair, wearing pink, vibrant backdrop of Malibu beach, styled in a chic and tailored pastel suit without a tie, iconic windswept hair, flawless dramatic lighting with soft shadows, captured with a 100mm Leica Summilux f/1.4 lens, showcasing intricate details and capturing the essence of modern masculinity and style',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-60707ed3-eb51-4236-841b-572679938c47/generated_images/1.png',
  //     list: 'gender_neutral',
  //     priority: 1,
  //   },
  //   {
  //     id: 219,
  //     created_at: '2023-08-03T00:58:16.192744+00:00',
  //     prompt:
  //       '8k close up linkedin profile picture of {KEYWORD}, professional jack suite, professional headshots, photo-realistic, 4k, high-resolution image, workplace settings, upper body, modern outfit, professional suit, businessman, blurred background, glass building, office window',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-8cb0be6b-bdba-440b-9408-2351421b1b2b/generated_images/1.png',
  //     list: 'gender_neutral',
  //     priority: 1,
  //   },
  //   {
  //     id: 218,
  //     created_at: '2023-08-03T00:26:18.161678+00:00',
  //     prompt:
  //       '8k portrait of {KEYWORD} businesswoman cinematic medium shot, shallow depth of field, studio shoot, professional headshot, professional suit, black background, professional retouched skin',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-e7282e23-89da-430d-9ced-2683daa98ac5/generated_images/2.png',
  //     list: 'female',
  //     priority: 1,
  //   },
  //   {
  //     id: 72,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       'A breathtaking, high resolution image of the Milky Way galaxy stretching across a clear night sky, captured with intricate detail',
  //     categories: 'Stock Photos,Wallpapers',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-09c79906-02fd-4e57-bcf1-f28b8f58d932/generated_images/2.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 74,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       "An underwater scene featuring a colorful coral reef and a variety of tropical fish, sun rays penetrating the water's surface, photorealistic, high detail",
  //     categories: 'Wallpapers,Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-2fb616c5-852b-406d-a72b-3e102c64646e/generated_images/2.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 76,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       "8k cinematic photo of a realistic, highly detailed image of a space station orbiting Earth, Earth's horizon and the vastness of space in the background",
  //     categories: 'Stock Photos,Wallpapers',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-8859eff0-09b5-42c8-9447-e778c8a60df1/generated_images/3.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 83,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a majestic mountain landscape with snow-capped peaks, lush valleys, and a clear blue sky, invoking a sense of grandeur and serenity, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-ea1bab2a-478d-4693-ad44-30a54f1fe5ad/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 84,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a bustling city street filled with pedestrians, vibrant storefronts, and towering buildings, capturing the energy and diversity of urban life, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-b0c6044e-d891-4739-92f7-7dd1f5d04135/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 85,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of an appetizing food platter showcasing a variety of dishes, including savory appetizers, mouthwatering entrees, and delectable desserts, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-4f557480-3914-4b80-b2f9-af935cd11697/generated_images/1.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 86,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k close up portrait of a fitness enthusiast engaged in a workout routine, demonstrating strength, agility, and determination, inspiring a healthy and active lifestyle, high resolution, highly detailed',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-eac87305-e56f-41e3-8abc-34cf9e940a78/generated_images/1.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 88,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of architectural marvels featuring stunning buildings and structures from different time periods and architectural styles, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-f340ae6a-1fe1-4fbc-8d5e-25460136caf6/generated_images/1.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 89,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a vibrant autumn forest with colorful foliage, creating a picturesque scene of natural beauty, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-c46a8d10-c8c9-45e0-aaea-141981dabd92/generated_images/1.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 91,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a cup of hot coffee surrounded by coffee beans, evoking a cozy and comforting atmosphere, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-021b7927-fb66-4d23-9cb6-883b7adcf0e0/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 92,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a beautiful sunrise over a misty mountain range, with the golden rays of sunlight peeking through the clouds, creating a sense of awe and inspiration, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-309885b6-e5e6-4d0d-a120-efc7f88f50bf/generated_images/3.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 94,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k close-up portrait of a woman using a virtual reality headset, immersed in a virtual world, exploring the possibilities of technology and innovation, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-54af1296-9d2e-4ab9-af76-b835e26f3fe0/generated_images/2.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 95,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a serene lakeside landscape with calm waters reflecting the surrounding trees and mountains, creating a peaceful and tranquil atmosphere, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-25bd250d-b99d-4c0c-b2ed-1a3fe98fa2d9/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 96,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a colorful hot air balloon festival, with dozens of balloons taking flight against a clear blue sky, creating a vibrant and festive scene, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-c7606415-7125-4a8d-a6a5-3fceab743770/generated_images/1.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 97,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a modern smart home with automated devices and appliances, showcasing the convenience and efficiency of home automation, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-ac8aec75-ed59-49f0-963f-c0fd39e0c3ab/generated_images/1.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 98,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a captivating starry night sky over a peaceful countryside, with silhouettes of trees and a faint glow from distant villages, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-7dfbf4a2-e371-4dc1-b7e6-3117486807d9/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 99,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a stylish and organized home office setup with a comfortable workspace, modern furniture, and natural lighting, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-96f7227f-9de5-48e5-abe9-a4c735d0225b/generated_images/2.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 100,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a busy office with employees working at their desks, discussing ideas in meeting rooms, and interacting in common areas, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-e9eebee7-a073-4122-a3a6-728504c31da2/generated_images/1.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 101,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of an innovative technology concept, showcasing futuristic devices and cutting-edge advancements, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-e61ba1f6-521f-4b55-b3bd-d9529a0830a7/generated_images/1.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 102,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a joyful family playing board games together at home, creating fun and memorable moments, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-cde2f01a-a564-476f-9931-8b000935544f/generated_images/1.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 103,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a dense and mysterious forest with sunlight streaming through the trees, creating a magical atmosphere, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-33f267f5-3e24-4847-a23c-a47ec89f74f3/generated_images/1.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 104,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a tranquil garden pond, with water lilies, koi fish, and lush vegetation, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-aaae7b82-f568-453c-b544-35fcdee027af/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 105,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       "A close-up of a beagle's face, with its ears perked up and its eyes looking inquisitively. The beagle's fur is groomed and its nose is slightly wrinkled, as if it is sniffing the air. The background is blurred, with a hint of a park setting. Realistic, Close-up, Dog Park.",
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-373c751f-b323-4cc7-be92-1a66561562cd/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 106,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       "In this ultra-realistic stock photo, a close-up shot showcases the cutting-edge features of AMD EPYC processors. The image depicts a sleek, high-tech motherboard with the EPYC processor at its center, surrounded by intricate circuitry. The processor is highlighted with vibrant LED lights, emphasizing its power and performance. The image captures the processor's advanced architecture, featuring multiple cores and threads for enhanced multitasking capabilities. The attention to detail is impeccable, with every component and connection meticulously crafted to ensure accuracy. The image sparks curiosity.",
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-081298e7-f58c-4518-8ab3-f31b177f588e/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 123,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a vintage film camera, showcasing its retro design, mechanical dials, and the nostalgia of analog photography.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-dc20bbe7-b76c-4c77-9d3e-2a788dc95ac7/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 124,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a stylish and trendy wristwatch, featuring a sleek design, intricate details, and precise timekeeping.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-6b043633-6e98-496c-9675-372ee58fbabc/generated_images/1.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 127,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a refreshing glass of lemonade, with sliced lemons, ice cubes, and a garnish of mint leaves.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-2bb42bca-0d35-443c-a28e-0ba871a5d68d/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 129,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a vintage record player, with a vinyl record spinning, capturing the nostalgia and warmth of analog music.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-e5f4a2c2-7f13-4938-a2d3-ae72d0933eb8/generated_images/3.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 29,
  //     created_at: '2023-07-19T04:09:15.30899+00:00',
  //     prompt:
  //       '8k portrait close up face of bedraggled 40 year old man dark blond hair blue eyes, dirty with mud on his face, a little bloody, just finished a long trail run on the AT, dramatic lighting highly detailed, with shenandoah woods in the background',
  //     categories: '["Stock Photos"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-31cfbeb5-771f-4df5-bec0-6be59051d6d0/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 189,
  //     created_at: '2023-07-19T17:28:59.286179+00:00',
  //     prompt:
  //       '8k portrait of close-up high-resolution image of a fierce Viking warrior in battle gear, icy Nordic landscape in the background, captured in dramatic lighting with highly detailed composition',
  //     categories: 'Stock Photos,Characters',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-f793ef02-bd92-431d-a27f-6b73c5777383/generated_images/1.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 90,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a busy office workspace with employees collaborating, working on computers, and holding meetings, representing productivity and teamwork, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-8ac45d60-7bd6-4e58-af46-b10cde18d9ad/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 200,
  //     created_at: '2023-07-19T18:06:00.629025+00:00',
  //     prompt:
  //       '8k close-up portrait of a professional basketball player in action, dribbling the ball with intense focus and determination, high resolution, highly detailed.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-cfaee771-b7cf-4e4e-9325-f2d0584dee18/generated_images/2.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 206,
  //     created_at: '2023-07-21T23:14:23.068191+00:00',
  //     prompt:
  //       'realistic half-bust portrait photography of a beautiful {KEYWORD} face illuminated by neon lights, maniac tv series style, cyberpunk background, perfectly drawn eyes, perfectly drawn circles, high resolution, ultra realistic, sharp features, white balance, 32k, super-resolution, sharp focus, soft smooth lighting',
  //     categories: 'Characters, Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-92d1e2d7-521b-4a2c-9187-a318b2dfa261/generated_images/3.png',
  //     list: 'gender_neutral',
  //     priority: 0,
  //   },
  //   {
  //     id: 212,
  //     created_at: '2023-07-21T23:37:06.660284+00:00',
  //     prompt:
  //       "80's portrait of {KEYWORD}, blue background, white pearl neckless, fashion model in oversized white clothes, official balmain editorial, dramatic lighting highly detailed, analog photo, overglaze, 80mm Sigma f/1.4 or any ZEISS lens",
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-e44d9def-523a-4e65-8645-871e2f22da40/generated_images/1.png',
  //     list: 'gender_neutral',
  //     priority: 0,
  //   },
  //   {
  //     id: 125,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       '8k portrait of a classic red wine bottle, with a label showcasing its origin, vintage, and the rich color of the wine.',
  //     categories: 'Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-47a950e6-38dc-4989-82ff-37ca3d656ba4/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 33,
  //     created_at: '2023-07-19T04:16:03.307498+00:00',
  //     prompt:
  //       '8k portrait close-up of a cute and playful Golden Retriever puppy in a green garden, playing with a red ball, sunny day, photorealistic, high detail',
  //     categories: '["Stock Photos"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-8defa7ef-8214-4417-a3ad-8bdfd34e7ff7/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 34,
  //     created_at: '2023-07-19T04:16:47.001933+00:00',
  //     prompt:
  //       '8k portrait of an enchanting, well-groomed Persian cat with luxurious white fur and captivating emerald eyes, lounging on an elegant silk cushion in a grandiose living room setting, photorealistic and rich in detail',
  //     categories: '["Stock Photos"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-f522cbea-0e12-42bb-a1ce-bacf69f023d1/generated_images/2.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 36,
  //     created_at: '2023-07-19T04:18:14.596601+00:00',
  //     prompt:
  //       'Highly detailed, photorealistic image of a latest luxury sports car with a sleek and shiny black finish, dramatic lighting, positioned in a spacious warehouse, rendered in 4K',
  //     categories: '["Stock Photos"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-bf35b2e6-c28c-476c-b651-69baed69f3bf/generated_images/2.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 38,
  //     created_at: '2023-07-19T04:19:46.363124+00:00',
  //     prompt:
  //       'A modern, minimalist office space featuring clean lines, a sleek desk, ergonomic chair, and panoramic windows with a cityscape view, photorealistic, high detail',
  //     categories: '["Stock Photos","Real Estate"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-1e918f40-1614-4af6-8a4e-81592f0c9551/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 39,
  //     created_at: '2023-07-19T04:20:37.017018+00:00',
  //     prompt:
  //       'A vibrant, detailed image of a traditional Indian market (bazaar) with various stalls selling spices, textiles, and handicrafts, people bustling about, high resolution',
  //     categories: '["Stock Photos"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-89b1eac2-dfe4-46dd-bd23-718a67458348/generated_images/1.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 40,
  //     created_at: '2023-07-19T04:22:20.298159+00:00',
  //     prompt:
  //       'Delicious, photorealistic gourmet hamburger with fresh lettuce, ripe tomato, juicy patty, and creamy cheese, served on a rustic wooden table, high resolution, highly detailed',
  //     categories: '["Stock Photos"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-d0fe28e0-cdd0-46b8-b576-60ea38744a72/generated_images/0.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 41,
  //     created_at: '2023-07-19T04:23:25.09825+00:00',
  //     prompt:
  //       'A luscious, detailed image of a traditional Italian pizza Margherita with melted mozzarella, fresh basil, and ripe tomatoes, served on a rustic wooden table, high resolution',
  //     categories: '["Stock Photos"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-da709827-2705-4785-9718-a92ce956bf1a/generated_images/3.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 44,
  //     created_at: '2023-07-19T04:26:25.956685+00:00',
  //     prompt:
  //       '8k portrait of a classic scene from a spaghetti western movie, featuring a gunslinger in a dusty desert town, high noon, sun directly overhead, photorealistic, highly detailed',
  //     categories: '["Characters","Stock Photos"]',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-ffac2b1d-a011-4eee-9b3a-643dc18f6ff8/generated_images/3.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  //   {
  //     id: 70,
  //     created_at: '2023-07-19T15:27:06.313956+00:00',
  //     prompt:
  //       'A rustic cabin nestled in a snow-covered landscape, with smoke billowing from the chimney and soft, warm light from the windows, high resolution, highly detailed',
  //     categories: 'Wallpapers,Real Estate,Stock Photos',
  //     example_image_url:
  //       'https://static.tryleap.ai/image-gen-f9ef0eaa-1b2a-4c57-831b-71d1eac63b96/generated_images/2.png',
  //     list: 'default',
  //     priority: 0,
  //   },
  // ],
  Wallpapers: [
    {
      id: 131,
      created_at: '2023-07-19T15:27:06.313956+00:00',
      prompt:
        '8k portrait of a charming cottage in the countryside, surrounded by blooming flowers and lush green fields.',
      categories: 'Wallpapers',
      example_image_url:
        'https://static.tryleap.ai/image-gen-8c3695fd-fbff-4e38-9fab-83bc6450d7ab/generated_images/1.png',
      list: 'default',
      priority: 3,
    },
    // {
    //   id: 130,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of an impressionist painting, with vibrant brushstrokes, soft colors, and a dreamy atmosphere.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-d9bd67e6-baee-47ba-a9bb-ed04de3abc43/generated_images/3.png',
    //   list: 'default',
    //   priority: 3,
    // },
    {
      id: 71,
      created_at: '2023-07-19T15:27:06.313956+00:00',
      prompt:
        'A steampunk cityscape full of intricate gears and machinery, airships flying in the sky, industrial revolution inspired, ultra-realistic, high detail',
      categories: 'Art,Wallpapers,Comics',
      example_image_url:
        'https://static.tryleap.ai/image-gen-f29ad67c-7c8b-4c0a-89c3-1479b8c507c3/generated_images/1.png',
      list: 'default',
      priority: 0,
    },
    // {
    //   id: 72,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'A breathtaking, high resolution image of the Milky Way galaxy stretching across a clear night sky, captured with intricate detail',
    //   categories: 'Stock Photos,Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-09c79906-02fd-4e57-bcf1-f28b8f58d932/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 74,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     "An underwater scene featuring a colorful coral reef and a variety of tropical fish, sun rays penetrating the water's surface, photorealistic, high detail",
    //   categories: 'Wallpapers,Stock Photos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-2fb616c5-852b-406d-a72b-3e102c64646e/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 76,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     "8k cinematic photo of a realistic, highly detailed image of a space station orbiting Earth, Earth's horizon and the vastness of space in the background",
    //   categories: 'Stock Photos,Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-8859eff0-09b5-42c8-9447-e778c8a60df1/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 107,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'A minimalist wallpaper with a soothing gradient of pastel colors. The soft and gentle tones create a calm and relaxing atmosphere, perfect for those who prefer a clean and understated aesthetic on their screens.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-65f7a674-da95-4f59-ab71-65d684701e09/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 108,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'A vintage retro-style wallpaper inspired by the 80s, featuring neon colors, geometric shapes, and a nostalgic vibe. This lively and vibrant design brings a sense of nostalgia and fun to your screen.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-4d858ff4-5a4b-4305-8acf-9faa71a3323c/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 109,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'An elegant Victorian-era wallpaper with intricate floral patterns, ornate borders, and a rich color palette. This luxurious and sophisticated design adds a touch of timeless elegance to any device screen.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-724d5404-8a90-453a-aa9d-90ccbcfa0e1f/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 110,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'A contemporary abstract wallpaper with bold brush strokes and vibrant colors. This expressive and dynamic design adds a sense of creativity and artistic flair to your screen.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-a1851b5d-f0d9-49f0-b86e-759c1b432a80/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 111,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'A futuristic cyberpunk-style wallpaper featuring neon lights, high-tech elements, and a dystopian atmosphere. This edgy and futuristic design creates a visually striking and immersive experience on your screen.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-2f6356ab-50af-4d00-821f-77c6f3e92c29/generated_images/0.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 112,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'A dreamy watercolor wallpaper with soft, pastel tones and a gentle blending of colors. This delicate and whimsical design adds a touch of ethereal beauty to your screen.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-4ca5362d-7ccc-47ae-8c7d-77b638e0c14a/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 113,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'A serene and tranquil Zen-inspired wallpaper featuring a minimalist rock garden with carefully arranged stones and raked sand. This calming design brings a sense of peace and harmony to your screen.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-ea7e8039-d56b-4c89-aab3-61488f693d09/generated_images/0.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 114,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of a whimsical fairy tale-inspired wallpaper featuring enchanted forests, magical creatures, and a sense of wonder. This imaginative design adds a touch of fantasy and adventure to your screen.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-c5c04a01-f70f-4027-bd91-9f4bf6c89785/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 115,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of a serene and captivating seascape wallpaper capturing the gentle waves, sandy shores, and endless horizon of the ocean. This calming design evokes a sense of peace and tranquility.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-5603b8b5-0b6b-4ec0-b7ec-1af9637e7315/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 116,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of A breathtaking view of a cascading waterfall, surrounded by lush greenery and mist, creating a sense of awe and tranquility.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-49ab9401-68d7-4645-a7e3-082d74c3a1d7/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 117,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of A serene and mystical moonlit forest, with moonlight filtering through the trees and casting a soft glow on the forest floor.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-985c39de-1635-45bd-868a-89dc61d8a7ba/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 118,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of A majestic and snow-covered mountain peak, surrounded by a serene alpine landscape and clear blue skies.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-767ac183-52c0-40a6-a3ed-b24df6ff79a5/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 119,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of a captivating European cityscape, with historic architecture, winding streets, and charming cafes.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-ddb7b878-4a8c-4542-b7f3-b2f33dce1b7a/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 120,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of A tranquil and idyllic countryside scene, with a meandering river, grazing cows, and colorful wildflowers.',
    //   categories: 'Wallpapers,Art',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-6d513e29-a22f-472c-a1ed-e6ba58069cdb/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 121,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of An enchanting and magical winter wonderland, with snow-covered trees, ice crystals, and a sense of quiet serenity.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-35ff72e5-aace-4f11-a13f-c14adecfb1f9/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 122,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of A serene and peaceful bamboo forest, with tall bamboo stalks swaying gently in the wind and creating a calming atmosphere.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-8b301d50-dc9e-4b4c-8d44-83812bb2cec6/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 132,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of a surreal cosmic journey, with swirling galaxies, sparkling stars, and cosmic dust.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-44533bda-3e5d-4777-a61d-8cf3a0e3cecc/generated_images/0.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 133,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of an abstract geometric pattern, with vibrant colors, intricate shapes, and a modern design.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-f4fc8773-ccc5-4d06-a106-461d822cdbef/generated_images/0.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 134,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of a dreamy pastel-colored sky, with fluffy clouds, soft gradients, and a sense of serenity.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-81e770cc-26e5-4b62-b896-bf8fd6ed4ac0/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 135,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of a vintage travel poster, with retro typography, iconic landmarks, and a nostalgic vibe.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-7c22368f-5866-4a23-a8b1-126e8365290c/generated_images/0.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 136,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of a vintage concert poster, with a band name, tour dates, and artistic illustrations capturing the spirit of the music.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-e956ad4b-9636-48a3-9df1-bd1bcb57d823/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 137,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of a vintage advertisement poster, promoting a classic product with charming illustrations and persuasive copy.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-644c4ea8-5ca1-40e1-ba93-9cf9d5cd3026/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 138,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     '8k portrait of a nostalgic retro arcade scene, with colorful arcade machines, pixelated graphics, and a lively gaming atmosphere.',
    //   categories: 'Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-585df1d4-dcb0-4d78-8a99-2d1d7453dc63/generated_images/0.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 145,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     "8k portrait inspired by Wassily Kandinsky's 'Abstract Art,' featuring geometric shapes, vibrant colors, and spiritual themes.",
    //   categories: 'Wallpapers,Art',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-d831eb0a-5562-419c-85e0-b87eb37fa573/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 56,
    //   created_at: '2023-07-19T04:36:14.775547+00:00',
    //   prompt:
    //     'A bustling Parisian street scene at sunset, with vibrant colors and visible brush strokes, reminiscent of Impressionist masters like Claude Monet or Pierre-Auguste Renoir, high resolution, intricately detailed',
    //   categories: '["Art","Wallpapers"]',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-4070b58c-76a8-4083-9434-94b0caf09db2/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 59,
    //   created_at: '2023-07-19T15:20:10.283188+00:00',
    //   prompt:
    //     'galaxy full of colors, vibrant, epic composition, cinematic, Landscape veduta photo by Dan Mumford, detailed landscape painting, rendered in Enscape, Miyazaki, Nausicaa Ghibli, 4k detailed post processing, unreal engine',
    //   categories: 'Art,Wallpapers',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-f065cdd8-8cf9-47e1-8202-d1690b34d9d2/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 60,
    //   created_at: '2023-07-19T15:20:10.283188+00:00',
    //   prompt:
    //     'futuristic tree house, hyper realistic, epic composition, cinematic, landscape vista photography by Carr Clifton & Galen Rowell, Landscape veduta photo by Dustin Lefevre & tdraw, detailed landscape painting by Ivan Shishkin, rendered in Enscape, Miyazaki, Nausicaa Ghibli, 4k detailed post processing, unreal engine',
    //   categories: 'Art,Wallpapers,Comics',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-143abe1b-7910-4874-8864-2d6052ee18b7/generated_images/3.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 64,
    //   created_at: '2023-07-19T15:25:04.015728+00:00',
    //   prompt:
    //     'rustic countryside scene with wildflowers and a meandering stream; warm, golden light, pastoral landscape style, rich greens and vibrant blooms, photographed with a high-quality wide-angle lens',
    //   categories: 'Art,Wallpapers,Comics',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-eb438c1b-8e9b-45d7-be94-d0af03e8643f/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 68,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'An ancient and mystical forest, lit by moonlight, with towering trees, moss-covered stones, and a small, clear stream, inspired by a fantasy novel, high resolution, highly detailed',
    //   categories: 'Art,Wallpapers,Comics',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-612a5530-7536-42d5-b203-14600120f64b/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 69,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'futuristic sunset New York City skyline landscape vista photography by Carr Clifton & Galen Rowell, 16K resolution, Landscape veduta photo by Dustin Lefevre & tdraw, 8k resolution, detailed landscape painting by Ivan Shishkin, DeviantArt, Flickr, rendered in Enscape, Miyazaki, Nausicaa Ghibli, Breath of The Wild, 4k detailed post processing, atmospheric, hyper realistic, 8k, epic composition, cinematic, artstation —ar 16:9',
    //   categories: 'Art,Wallpapers,Comics',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-5a41bf2f-b69d-41f9-8d91-9b0f17db79ba/generated_images/1.png',
    //   list: 'default',
    //   priority: 0,
    // },
    // {
    //   id: 70,
    //   created_at: '2023-07-19T15:27:06.313956+00:00',
    //   prompt:
    //     'A rustic cabin nestled in a snow-covered landscape, with smoke billowing from the chimney and soft, warm light from the windows, high resolution, highly detailed',
    //   categories: 'Wallpapers,Real Estate,Stock Photos',
    //   example_image_url:
    //     'https://static.tryleap.ai/image-gen-f9ef0eaa-1b2a-4c57-831b-71d1eac63b96/generated_images/2.png',
    //   list: 'default',
    //   priority: 0,
    // },
  ],
};
